// extracted by mini-css-extract-plugin
module.exports = {"countryName":"ChangeCountryLanguage_countryName__z7FEu","button":"ChangeCountryLanguage_button__P2Yyv"};